import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Browser = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
        <path
          d='M14.656 8.73 10.55 9.85a1 1 0 0 0-.701.701l-1.12 4.105a.5.5 0 0 0 .614.614l4.105-1.12a1 1 0 0 0 .701-.701l1.12-4.105a.5.5 0 0 0-.614-.614'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m-1.449 7.6 4.105-1.12a.5.5 0 0 1 .614.614l-1.12 4.105a1 1 0 0 1-.701.701l-4.105 1.12a.5.5 0 0 1-.614-.614l1.12-4.105a1 1 0 0 1 .701-.701'
        fill='currentColor'
      />
    )}
  </IconBase>
);
